<style scoped>
.app-center {
  background-color: #fff;
  box-shadow: 1px -1px 13px 0px rgb(0 0 0 / 43%);
  padding: 15px;
  border-radius: 5px;
  display: block;
  max-width: 241px;
  height: 78px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 15px;
  margin-bottom: 10px;
}

.app-center h2 {
  text-align: left;
  float: left;
  width: 60%;
  font-size: 1rem;
  margin-left: 8%;
  color: #000;
  margin-top: 4px;
  line-height: 13px;
}

.app-center span {
  float: left;
  width: 100%;
  font-weight: 500;
  text-align: left;
  padding-top: 9px;
  font-size: 0.8rem;
  line-height: 9px;
}

.app-center b {
  font-weight: 500;
  font-size: 0.6rem;
  color: red;
}

@media (max-width: 321px) {
  .app-box {
    padding: 8px !important;
  }
  .app-box img {
    height: 30% !important;
    width: 60% !important;
  }
  .app-box-text {
    font-size: 0.8rem !important;
  }
}

.app-box {
  margin-top: 1rem;
  background-color: #deedf0;
  padding: 6px;
  border-radius: 5px;
  color: #fff;
  padding: 15px;
}

.app-box-text {
  text-align: center;
  color: #222;
  font-weight: 500;
  font-size: 0.9rem;
}

.app-box img {
  margin: 14px 0;
  height: 40%;
  width: 70%;
}
</style>
<template>
  <div class="home">
    <div class="alert alert-danger" style="display: none" id="pay_block">
      Please settle the following installments before accessing the Classrooms.
      <ul>
        <li v-for="(block, k) in block_payment" :key="k">
          installment {{ block.installment_no }} ({{ currency.symbol }}
          {{ numberWithCommas(block.outstanding_amount) }})
          <sup>{{ currency.code }}</sup>
        </li>
      </ul>
    </div>
    <!-- begin::reconsilation validation block -->
    <div class="alert alert-danger" style="display: none" id="reconsile_block">
      Please wait for the payment reconciliation process completed before
      accessing the Classrooms.
      <ul>
        <li v-if="block_reconsile">
          Reconciliation pending for some installment\s
        </li>
      </ul>
    </div>
    <!-- end::reconsilation validation block -->
    <div class="row">
      <div class="col-md-12">
        <!--begin::Portlet-->
        <div class="m-portlet classroom-page">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <span class="m-portlet__head-icon m--hide"
                  ><i class="la la-gear"></i
                ></span>
                <h3 class="m-portlet__head-text">Classrooms</h3>
                <a
                  href="#"
                  class="btn m-btn--pill btn-info"
                  data-toggle="modal"
                  data-target="#guide-modal"
                >
                  <img src="media/icons/info.png" /> Classroom Guide
                </a>
              </div>
            </div>
          </div>
          <div class="m-portlet__body">
            <div class="row">
              <div class="col-md-12">
                <!-- <div class="alert alert-danger speed_test_msg no-margin-b custom-msg text-center" style="display: none;">
                  <span>Your internet speed is</span>
                  <span class="internet_speed_value"></span>
                  <span class="internet_speed_msg"></span>
                </div> -->
                <div
                  class="
                    alert alert-warning
                    classroom_empty_msg
                    no-margin-b
                    custom-msg
                  "
                  style="display: none"
                >
                  No Upcoming Classrooms
                </div>
                <div
                  class="
                    alert alert-warning
                    classroom_not_started_msg
                    no-margin-b
                    custom-msg
                  "
                  style="display: none"
                >
                  This meeting has not been started yet.!
                </div>
                <div
                  class="
                    alert alert-warning
                    error_message
                    no-margin-b
                    custom-msg
                  "
                  style="display: none"
                >
                  <p id="errorMsg"></p>
                </div>
                <div
                  class="internet-status speed_test_msg"
                  style="display: none"
                >
                  <div class="desx">
                    <h3>Your internet speed is</h3>
                    <span class="internet_speed_value"></span>
                  </div>
                  <div class="other-msg">
                    <span class="internet_speed_msg"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12" id="loading-hide">
                <div v-if="viewRecentClass" class="m-portlet__body">
                  <!--begin::Widget 7-->
                  <div class="m-widget7--skin-danger">
                    <div class="m-widget7__desc text-center">
                      <div class="top-name">
                        Hi <b>{{ recent_class.student_name }},</b>
                      </div>
                      <div class="meet-held">
                        Your next live meeting will be on <br />
                        <b class="m--font-info">{{ recent_class.date }}.</b>
                        <br />
                      </div>
                      <div class="teacher">
                        Your Host : <b>{{ recent_class.teacher }}</b>
                      </div>
                      <div v-if="recent_class.course_name" class="teacher">
                        Course : <b>{{ recent_class.course_name }}</b>
                      </div>
                      <div v-if="recent_class.student_note != '-'" class="ask">
                        Message : "{{ recent_class.student_note }}"
                      </div>
                    </div>

                    <div class="m-widget7__button text-center pt-1">
                      <div v-if="classroom_join != 0">
                        <!-- if mobile web -->
                        <!-- <button
                          v-if="!isApp && isMobile"
                          class="
                            m-btn m-btn--pill
                            btn btn-accent
                            up-btn
                            btn-top btn-info
                          "
                          data-dismiss="modal"
                          v-on:click="showClassRoom()"
                          role="button"
                        >
                          Join Classroom
                        </button> -->
                        <!-- if mobile app -->
                        <button
                          v-if="isApp && isMobile"
                          class="
                            m-btn m-btn--pill
                            btn btn-accent
                            up-btn
                            btn-top btn-info
                          "
                          data-dismiss="modal"
                          v-on:click="showClassRoom()"
                          role="button"
                        >
                          Join Classroom
                        </button>
                        <!-- if desktop -->
                        <button
                          v-if="!isApp && !isMobile"
                          class="
                            m-btn m-btn--pill
                            btn btn-accent
                            up-btn
                            btn-top btn-info
                          "
                          data-dismiss="modal"
                          v-on:click="showClassRoom()"
                          role="button"
                        >
                          Join Classroom
                        </button>
                      </div>
                      <!-- <a
                              target="_blank"
                              v-show="(isApp = 'false' && isMobile)"
                              href="https://install.appcenter.ms/users/prasadwebco-gmail.com/apps/webco-lms-android/distribution_groups/prod"
                              >Click here to Download app</a
                            > -->

                      <!-- <button v-if="classroom_join != 0 && isMobile" href="#" class="m-btn m-btn--pill btn btn-accent up-btn btn-top btn-info" data-toggle="modal" data-target="#join-modal" >
                              Join Classroom
                            </button> -->
                    </div>
                    <!-- if mobile -->
                    <div class="app-box" v-if="!isApp && isMobile">
                      <div class="app-box-text">
                        For better performance download our App
                      </div>

                      <a
                        v-show="!isApp && isMobile"
                        href="https://play.google.com/store/apps/details?id=com.webchoice.webcolms"
                        target="_blank"
                      >
                        <div class="text-center">
                          <img src="../../public/images/playstore.png" />
                        </div>
                      </a>
                    </div>
                    <!-- common -->
                    <div
                      class="extra-options text-center mt-3"
                      v-if="recent_class.classroom && recent_class.classroom.zoom_direct_link == 'yes' && zoom_direct_link"
                    >
                      Unable to join?
                      <a
                        target="_blank"
                        :href="direct_link_href"
                        style="cursor: pointer"
                        v-on:click="showDirectLink()"
                        >Click here & join</a
                      >
                    </div>
                  </div>
                  <!--end::Widget 7-->
                </div>
                <!--<div class="m-portlet" id="classroom_live">-->
                <!--                  <div id="zmmtg-root"></div>-->
                <!--                  <div id="aria-notify-area"></div>-->
                <!-- added on meeting init -->
                <!--                  <div class="ReactModalPortal"></div>-->
                <!--                  <div class="ReactModalPortal"></div>-->
                <!--                  <div class="ReactModalPortal"></div>-->
                <!--                  <div class="ReactModalPortal"></div>-->
                <!--                  <div class="global-pop-up-box"></div>-->
                <!--                  <div class="sharer-controlbar-container sharer-controlbar-container&#45;&#45;hidden"></div>-->

                <!-- <div class="iframe-container" style="overflow: hidden; height: 100%; position: relative; float: left; width: 100%">
                    <iframe id="live_study" allow="microphone; camera" style="border: 0; max-height: 600px; width: 100%;" src="" frameborder="0"></iframe>
                  </div> -->
                <!--</div>-->
                <div class="m-portlet">
                  <div class="m-portlet__body">
                    <ul class="nav nav-tabs m-tabs-line" role="tablist">
                      <li class="nav-item m-tabs__item">
                        <a
                          class="nav-link m-tabs__link active"
                          data-toggle="tab"
                          href="#m_tabs_6_1"
                          role="tab"
                          >Upcoming Classrooms</a
                        >
                      </li>
                      <li class="nav-item m-tabs__item">
                        <a
                          class="nav-link m-tabs__link"
                          data-toggle="tab"
                          href="#m_tabs_6_3"
                          role="tab"
                          >Classrooms History</a
                        >
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div
                        class="tab-pane active"
                        id="m_tabs_6_1"
                        role="tabpanel"
                      >
                        <div class="m-portlet__body">
                          <div class="row" v-if="loaderlist">
                            <div class="col-md-12 col-lg-6 col-xl-6">
                              <div class="modern-card loading-box">
                                Data loading...
                                <facebook-loader></facebook-loader>
                              </div>
                            </div>
                            <div
                              class="col-md-12 col-lg-6 col-xl-6 mobile-hide"
                            >
                              <div class="modern-card loading-box">
                                Data loading...
                                <facebook-loader></facebook-loader>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="all_class.length > 0">
                            <div
                              class="col-md-12 col-lg-6 col-xl-6"
                              v-for="(item, index) in all_class"
                              :key="index"
                            >
                              <div class="modern-card class-card">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div class="class-head">
                                      <div class="row">
                                        <div class="col-md-3">
                                          <div class="class-icon">
                                            <img
                                              src="/media/icons/classroom.png"
                                            />
                                          </div>
                                        </div>
                                        <div class="col-md-9">
                                          <div class="row">
                                            <div class="col-md-12">
                                              <h2>{{ item.classroom.name }}</h2>
                                              <span class="t-name">{{
                                                item.classroom.user
                                              }}</span>
                                              <b class="date">{{
                                                item.date
                                              }}</b>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="class-body">
                                    <div class="col-md-12">
                                      <p
                                        v-if="item.classroom.description"
                                        style="margin-bottom: 7px"
                                      >
                                        {{ item.classroom.description }}
                                      </p>
                                      <p
                                        v-if="item.student_note != '-'"
                                        style="margin-bottom: 7px"
                                      >
                                        {{ item.student_note }}
                                      </p>
                                      <button
                                        v-if="classroom_join != 0"
                                        class="btn btn-info"
                                        v-on:click="switchClassRoom(item.id)"
                                        role="button"
                                      >
                                        Switch Classroom
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" v-if="!no_data">
                            <div class="col-md-12">
                              <div class="empty-data">
                                <img src="/media/icons/empty.png" />
                                <h2>No Records Available</h2>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="tab-pane" id="m_tabs_6_3" role="tabpanel">
                        <div class="m-portlet__body">
                          <div class="row" v-if="old_class.length > 0">
                            <div
                              class="col-md-12 col-lg-6 col-xl-6"
                              v-for="(item, index) in old_class"
                              :key="index"
                            >
                              <div class="modern-card class-card">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div class="class-head">
                                      <div class="row">
                                        <div class="col-md-3">
                                          <div class="class-icon">
                                            <img
                                              src="/media/icons/classroom.png"
                                            />
                                          </div>
                                        </div>
                                        <div class="col-md-9">
                                          <div class="row">
                                            <div class="col-md-12">
                                              <h2>{{ item.classroom.name }}</h2>
                                              <span class="t-name">{{
                                                item.classroom.user
                                              }}</span>
                                              <b class="date">{{
                                                item.date
                                              }}</b>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="class-body">
                                    <div class="col-md-12">
                                      <p v-if="item.classroom.description">
                                        {{ item.classroom.description }}
                                      </p>
                                      <p v-if="item.student_note != '-'">
                                        {{ item.student_note }}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-else class="row">
                            <div class="col-md-12">
                              <div class="empty-data">
                                <img src="/media/icons/empty.png" />
                                <h2>No Records Available</h2>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="loader_wrapper" v-if="isLoading">
            <div class="loader_block">
              <loading
                :active.sync="isLoading"
                :color="'#f7941d'"
                :loader="'spinner'"
                :can-cancel="false"
                :is-full-page="false"
              ></loading>
            </div>
          </div>
        </div>
        <!--end::Portlet-->
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal modern fade"
      id="guide-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Classroom Guide</h5>
            <img
              class="close"
              src="/media/icons/close.png"
              data-dismiss="modal"
              aria-label="Close"
              width="53px"
            />
          </div>
          <div class="modal-body guide-modal">
            <ul
              class="nav nav-tabs"
              id="myTab"
              role="tablist"
              v-if="guide.length > 0"
            >
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="home-tab"
                  data-toggle="tab"
                  href="#home"
                  role="tab"
                  aria-controls="home"
                  aria-selected="true"
                  >Special Guide</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="profile-tab"
                  data-toggle="tab"
                  href="#profile"
                  role="tab"
                  aria-controls="profile"
                  >System Guide</a
                >
              </li>
            </ul>
            <ul class="nav nav-tabs" id="myTab" role="tablist" v-else>
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="profile-tab"
                  data-toggle="tab"
                  href="#profile"
                  role="tab"
                  aria-controls="profile"
                  aria-selected="true"
                  >System Guide</a
                >
              </li>
            </ul>
            <div class="tab-content" id="myTabContent" v-if="guide.length > 0">
              <div
                class="tab-pane fade show active"
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                <div class="guideline">
                  <ul>
                    <li v-for="(guides, index) in guide" :key="index">
                      <span>{{ index + 1 }}</span
                      >{{ guides.title }}
                    </li>
                  </ul>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="profile"
                role="tabpanel"
                aria-labelledby="profile-tab"
              >
                <div class="guideline">
                  <ul>
                    <li><span>1</span>Click on '<b>Join now</b>' button</li>
                    <li>
                      <span>2</span>Wait for the panel to open OR teacher to
                      accept your request
                    </li>
                    <li>
                      <span>3</span>Else, you will see a message "<b
                        >The meeting has not been started yet</b
                      >", then please try again later
                    </li>

                    <li>
                      <span>4</span>Once joined you can see the participants
                    </li>
                    <li>
                      <span>5</span>You can use your computer audio OR mute the
                      audio
                    </li>
                    <li><span>6</span>You can enable or disable your video</li>
                    <li>
                      <span>7</span>Only allow to Record the meeting if you have
                      permission for that
                    </li>
                    <li>
                      <span>8</span>Only support to Share screen if you have
                      permission for that
                    </li>
                    <li>
                      <span>9</span>Click on the chat icon to make a chat with
                      participant or teacher *Click the same chat icon for close
                      chat panel
                    </li>
                    <li>
                      <span>10</span>Click on '<b>Leave meeting</b>' button to
                      leave the meeting
                    </li>
                    <li><span>11</span>You can switch between meetings</li>
                    <li>
                      <span>12</span>Also you can view the meeting history and
                      upcoming classrooms
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="tab-content" id="myTabContent" v-else>
              <div
                class="tab-pane fade show active"
                id="profile"
                role="tabpanel"
                aria-labelledby="profile-tab"
              >
                <div class="guideline">
                  <ul>
                    <li><span>1</span>Click on '<b>Join now</b>' button</li>
                    <li>
                      <span>2</span>Wait for the panel to open OR teacher to
                      accept your request
                    </li>
                    <li>
                      <span>3</span>Else, you will see a message "<b
                        >The meeting has not been started yet</b
                      >", then please try again later
                    </li>

                    <li>
                      <span>4</span>Once joined you can see the participants
                    </li>
                    <li>
                      <span>5</span>You can use your computer audio OR mute the
                      audio
                    </li>
                    <li><span>6</span>You can enable or disable your video</li>
                    <li>
                      <span>7</span>Only allow to Record the meeting if you have
                      permission for that
                    </li>
                    <li>
                      <span>8</span>Only support to Share screen if you have
                      permission for that
                    </li>
                    <li>
                      <span>9</span>Click on the chat icon to make a chat with
                      participant or teacher *Click the same chat icon for close
                      chat panel
                    </li>
                    <li>
                      <span>10</span>Click on '<b>Leave meeting</b>' button to
                      leave the meeting
                    </li>
                    <li><span>11</span>You can switch between meetings</li>
                    <li>
                      <span>12</span>Also you can view the meeting history and
                      upcoming classrooms
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Select classroom modal -->
    <div
      style="z-index: 99"
      class="modal fade"
      id="join-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Select a classroom
            </h5>
            <img
              src="/media/icons/close.png"
              data-dismiss="modal"
              aria-label="Close"
              width="53px"
              class="close"
            />
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-6" v-if="classroom_join != 0">
                <div
                  class="class-box"
                  v-on:click="showClassRoom()"
                  data-dismiss="modal"
                >
                  <div class="inner-clz-box">
                    <img src="images/classroom1.png" />
                  </div>
                  Classroom 1
                </div>
              </div>
              <div
                class="col-6"
                v-if="recent_class.classroom && !zoom_direct_link"
              >
                <a
                  target="_blank"
                  :href="recent_class.classroom.link"
                  data-dismiss="modal"
                >
                  <div class="class-box">
                    <div class="inner-clz-box">
                      <img src="images/classroom2.png" />
                    </div>
                    Classroom 2
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { FacebookLoader } from "vue-content-loader";
import { isMobile } from "mobile-device-detect";
import moment from "moment";
import Vue from "vue";
var Loading = require("vue-loading-overlay");
require("vue-loading-overlay/dist/vue-loading.css");

var $ = require("jquery");
var Config = require("../router/Config");
var Cookies = require("vue-cookies");
const crypto = require("crypto");
Vue.use(require("vue-moment"));

var classrooms = {
  name: "classroom",
  components: { FacebookLoader, Loading },
  data() {
    return {
      logo_url: Config.LOGO_URL(),
      no_data: true,
      appOS: Cookies.get("appos"),
      loaderlist: true,
      api_url: Config.API_URL,
      viewRecentClass: false,
      recent_class: [],
      all_class: [],
      old_class: [],
      classroom: [],
      empty: " Subject not found selected course!",
      isHidden: false,
      passcode: null,
      meeting_id: null,
      zoomAPI_KEY: Config.zoomAPIKey,
      zoomAPI_SECRET: Config.zoomAPISecret,
      isLoading: false,
      user: [],
      currency: [],
      block_payment: [],
      block_reconsile: [],
      isPaymentDone: true,
      isReconcilationDone: true,
      classroom_join: 0,
      zoom_direct_link: 0,
      isMobile: isMobile,
      guide: [],
      networkSpeed: null,
      networkType: null,
      userPermissions: [],
      isApp: false,
      direct_link_href: "",
    };
  },
  beforeMount() {
    $("#zmmtg-root").removeClass("zoom-befor-load");
    setTimeout(function () {
      $("#zmmtg-root").addClass("zoom-befor-load");
    }, 3000);
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "https://source.zoom.us/zoom-meeting-2.1.1.min.js"
    );
    document.head.appendChild(recaptchaScript);
  },
  mounted() {
    $("#zmmtg-root").addClass("zoom-befor-load");
    var and_app = Cookies.get("is_app_log");
    if (and_app == "true") {
      this.isApp = true;
    }
    this.userPermissions = Cookies.get("userPermissions");
    this.classroom_join = this.userPermissions.classroom_join;
    this.zoom_direct_link = this.userPermissions.zoom_direct_link;
    this.getChapterInfo();
    this.classRoomGuid();
    this.user = Cookies.get("userDetail");
    this.currency = Cookies.get("currency");
    this.getNetworkBandwith();
    setTimeout(function () {
      $("#zmmtg-root").addClass("zoom-befor-load");
    }, 2000);
  },
  methods: {
    getNetworkBandwith: function () {
      var con =
        navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnetion;
      this.networkSpeed = con.downlink;
      this.networkType = con.effectiveType;
      console.log(con);
      console.log(this.networkType);
      if (this.networkSpeed < 1) {
        $(".speed_test_msg").show();
        $(".internet_speed_value")
          .empty()
          .html(this.networkSpeed + " Mbps");
        $(".internet_speed_msg")
          .empty()
          .html(
            "Your internet speed is slower than the recommended speed for live classrooms. You may experience difficulties when connecting to the classroom"
          );
      }
    },
    getChapterInfo: function () {
      this.no_data = true;
      this.axios
        .post(
          this.api_url +
            "/api/fe/student/classroom?token=" +
            Cookies.get("accessToken"),
          {
            studentId: Cookies.get("studentId"),
          }
        )
        .then((response) => {
          if (response.data.latest == null) {
            $(".classroom_empty_msg").show();
          }
          if (response.data.history) {
            this.old_class = response.data.history;
          }
          if (response.data.latest) {
            this.recent_class = response.data.latest;
            this.viewRecentClass = true;
            this.passcode = response.data.latest.classroom.passcode;
            this.meeting_id = response.data.latest.classroom.meeting_id.replace(
              /\s+/g,
              ""
            );
            if (this.userPermissions.check_payment) {
              this.checkPayment(this.recent_class.course_id);
            }
          }
          if (response.data.data) {
            this.all_class = response.data.data;
            this.loaderlist = false;
            this.no_data = true;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    showClassRoom: function () {
      var self = this;
      this.isLoading = true;
      var timeok = this.checkTime();
      if (this.isPaymentDone) {
        if (this.isReconcilationDone) {
        //   if (timeok) {
            this.isHidden = true;
            this.passcode = this.recent_class.classroom.passcode;
            this.meeting_id = this.recent_class.classroom.meeting_id.replace(
              /\s+/g,
              ""
            );
            if (this.isMobile) {
              var meetingJsonString = JSON.stringify({
                MeetingID: this.meeting_id,
                Passcode: this.passcode,
              });
              this.joinClassroomFromMobileApp(
                Cookies.get("appos"),
                meetingJsonString
              );
              this.isLoading = false;
            } else {
              $("#zmmtg-root").removeClass("zoom-befor-load");
              $(".default-layout").addClass("default-layout-none");
              window.ZoomMtg.setZoomJSLib(
                "https://source.zoom.us/2.1.1/lib",
                "/av"
              );
              window.ZoomMtg.preLoadWasm();
              window.ZoomMtg.prepareJssdk();
              console.log("generateSignature");
              const signatureZoom = this.generateSignature(
                this.zoomAPI_KEY,
                this.zoomAPI_SECRET,
                this.meeting_id,
                0
              );
              const meetConfig = {
                apiKey: this.zoomAPI_KEY,
                meetingNumber: this.meeting_id,
                leaveUrl: "/classroom",
                userName:
                  Cookies.get("student_number") ? (Cookies.get("student_number") + " : " + Cookies.get("firstName") + " " + Cookies.get("lastName")) : (Cookies.get("firstName") + " " + Cookies.get("lastName")),
                userEmail: Cookies.get("email"),
                passWord: this.passcode, // if required
                role: 0, // 1 for host; 0 for attendee
              };

              window.ZoomMtg.init({
                isShowJoiningErrorDialog: false,
                leaveUrl: meetConfig.leaveUrl,
                isSupportAV: true,
                videoHeader: true, //optional,
                disablePreview: false,
                showMeetingHeader: true,
                videoDrag: true,
                disableRecord: true,
                meetingInfo: ["topic", "participant", "report"],
                success: function () {
                  console.log("signatureZoom");
                  console.log(signatureZoom);
                  window.ZoomMtg.join({
                    signature: signatureZoom,
                    apiKey: meetConfig.apiKey,
                    meetingNumber: meetConfig.meetingNumber,
                    userName: meetConfig.userName,
                    // password optional; set by Host
                    passWord: meetConfig.passWord,
                    success: function (res) {
                      self.isLoading = false;
                      $("body").addClass("liveclassbody");
                      console.log("join meeting success");
                      self.addAttendance();
                      console.log(res);
                    },
                    error: function (error) {
                      self.isLoading = false;
                      $("body").removeClass("liveclassbody");
                      console.log("Join meeting Error");
                      console.log(error.errorMessage);
                      if (error.errorCode == 3008) {
                        $(".classroom_not_started_msg")
                          .fadeTo(5000, 500)
                          .slideUp(500, function () {
                            $(".classroom_not_started_msg").slideUp(500);
                          });
                      } else {
                        $("#errorMsg").empty().html(error.errorMessage);
                        $(".error_message")
                          .fadeTo(5000, 500)
                          .slideUp(500, function () {
                            $(".error_message").slideUp(500);
                          });
                      }
                    },
                  });
                },
              });
              // window.open(this.recent_class.classroom.link, '_blank')
            }
        //   } else {
        //     $(".classroom_not_started_msg")
        //       .fadeTo(5000, 500)
        //       .slideUp(500, function () {
        //         $(".classroom_not_started_msg").slideUp(500);
        //       });
        //     console.log("This meeting has not been started yet");
        //     this.isHidden = false;
        //     this.isLoading = false;
        //   }
        } else {
          $("#reconsile_block")
            .fadeTo(5000, 500)
            .slideUp(500, function () {
              $("#reconsile_block").slideUp(500);
            });
          this.isLoading = false;
        }
      } else {
        $("#pay_block")
          .fadeTo(5000, 500)
          .slideUp(500, function () {
            $("#pay_block").slideUp(500);
          });
        this.isLoading = false;
      }
    },
    showDirectLink: function () {
      this.isLoading = true;
      var timeok = this.checkTime();
      if (this.isPaymentDone) {
        if (this.isReconcilationDone) {
          // if (timeok) {
            this.isLoading = false;
            window.open(this.recent_class.classroom.link, "_blank");
            this.direct_link_href = this.recent_class.classroom.link;
          // } else {
          //   $(".classroom_not_started_msg")
          //     .fadeTo(5000, 500)
          //     .slideUp(500, function () {
          //       $(".classroom_not_started_msg").slideUp(500);
          //     });
          //   console.log("This meeting has not been started yet");
          //   this.isHidden = false;
          //   this.isLoading = false;
          // }
        } else {
          $("#reconsile_block")
            .fadeTo(5000, 500)
            .slideUp(500, function () {
              $("#reconsile_block").slideUp(500);
            });
          this.isLoading = false;
        }
      } else {
        $("#pay_block")
          .fadeTo(5000, 500)
          .slideUp(500, function () {
            $("#pay_block").slideUp(500);
          });
        this.isLoading = false;
      }
    },
    switchClassRoom: function (id) {
      this.axios
        .post(
          this.api_url +
            "/api/fe/student/classroom-by-id?token=" +
            Cookies.get("accessToken"),
          {
            id: id,
          }
        )
        .then((response) => {
          this.recent_class = response.data.data;
          this.passcode = response.data.data.classroom.passcode;
          this.meeting_id = response.data.data.classroom.meeting_id.replace(
            /\s+/g,
            ""
          );
          console.log("Successfully switch classroom");
          if (this.userPermissions.check_payment) {
            this.checkPayment(this.recent_class.course_id);
          }
          // if (response.data == null) {
          //     $('.classroom_empty_msg').show()
          // }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    generateSignature: function (apiKey, apiSecret, meetingNumber, role) {
      // Prevent time sync issue between client signature generation and zoom
      const timestamp = new Date().getTime() - 30000;
      const msg = Buffer.from(
        apiKey + meetingNumber + timestamp + role
      ).toString("base64");
      const hash = crypto
        .createHmac("sha256", apiSecret)
        .update(msg)
        .digest("base64");
      const signature = Buffer.from(
        `${apiKey}.${meetingNumber}.${timestamp}.${role}.${hash}`
      ).toString("base64");

      return signature;
    },
    classRoomGuid: function () {
      this.axios
        .post(
          this.api_url +
            "/api/fe/classroom/guide?token=" +
            Cookies.get("accessToken"),
          {
            student_id: Cookies.get("studentId"),
          }
        )
        .then((response) => {
          this.guide = response.data.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    joinClassroomFromMobileApp: function (appos, message) {
      try {
        if (appos === "ios") {
          if (window.webkit) {
            window.webkit.messageHandlers.join.postMessage(message);
          }
        } else if (appos === "android") {
          Android.join(message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    checkPayment: function (courseId) {
      var courseID = courseId;
      var self = this;
      this.axios
        .post(
          Config.API_URL +
            "/api/fe/payments/check?token=" +
            Cookies.get("accessToken"),
          {
            user_id: self.user.student[0].id,
            course_id: courseID,
          }
        )
        .then((response) => {
          this.block_payment = response.data.data;
          if (!response.data.is_can) {
            self.isPaymentDone = false;
          } else {
            self.isPaymentDone = true;
            self.checkReconsilation(courseId);
          }
        })
        .catch(function (error) {
          return error;
        });
    },
    checkTime: function () {
      var started_at = this.recent_class.started;
      var end_at = this.recent_class.ended;
      var CurrentDate = moment(String(new Date())).format("YYYY-MM-DD H:mm:ss");
      if (
        moment(CurrentDate).isBetween(
          moment(String(started_at)).format("YYYY-MM-DD H:mm:ss"),
          moment(String(end_at)).format("YYYY-MM-DD H:mm:ss")
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    addAttendance: function () {
      this.axios
        .post(
          this.api_url +
            "/api/fe/student/classroom-check-time?token=" +
            Cookies.get("accessToken"),
          {
            start_at: this.recent_class.started,
            end_at: this.recent_class.ended,
            id: this.recent_class.id,
            user_id: Cookies.get("userId"),
          }
        )
        .then((response) => {
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    checkReconsilation: function (courseId) {
      var courseID = courseId;
      var self = this;
      this.axios
        .post(
          Config.API_URL +
            "/api/fe/payments/check-reconcilation?token=" +
            Cookies.get("accessToken"),
          {
            user_id: self.user.student[0].id,
            course_id: courseID,
          }
        )
        .then((response) => {
          this.block_reconsile = response.data.data;
          if (!response.data.is_can) {
            self.isReconcilationDone = false;
          } else {
            self.isReconcilationDone = true;
          }
        })
        .catch(function (error) {
          return error;
        });
    },
  },
};
export default classrooms;
</script>

<style scoped lang="scss">
@import "../assets/scss/component/classroom/classroom";
</style>
